import React from 'react';

import { useReviewsContent } from '@hooks/useContent';
import { SwiperComponent } from 'vitl-component-library';
import styles from './reviews.module.scss';

export interface IReview {
  reviewerName: string;
  review: string;
}

interface IProps {
  title?: string;
  items?: IReview[];
  backgroundColor?: string;
  showReview?: boolean;
  hideTrustPilot?: boolean;
  variationYellow?: boolean;
  variationLightYellow?: boolean;
  trustpilotIframe?: React.ReactNode | false;
  hideImage: boolean;
  customImage?: string;
  className?: string;
}

const Reviews: React.FC<IProps> = ({
  title,
  items,
  backgroundColor = '',
  showReview = false,
  hideTrustPilot = true,
  variationYellow = false,
  variationLightYellow = false,
  trustpilotIframe = false,
  hideImage = false,
  customImage,
  className = '',
}) => {
  const { directusHome } = useReviewsContent();

  const sliderItems = items || directusHome.reviews_items;
  const sectionTitle = title || directusHome.reviews_title;
  const hasTrustpilot = !hideTrustPilot && trustpilotIframe;

  if (!(directusHome.reviews_show || showReview)) {
    return null;
  }

  const getVariation = () => {
    if (variationYellow) return styles.yellow;
    if (variationLightYellow) return styles.lightYellow;
    return '';
  };

  const currentImage = () => {
    if (customImage) return customImage;
    if (variationYellow) return '/images/gradient-background.png';
    if (variationLightYellow || hideImage) return '';
    return '/images/reviews-bg-tiny.jpeg';
  };

  return (
    <section
      className={`${styles.section} ${getVariation()} ${className}`}
      style={{ backgroundImage: `url(${currentImage()})`, backgroundColor }}
    >
      <div className={styles.container}>
        <>
          <h2 className={`${styles.sectionTitle} ${hasTrustpilot ? styles.withTrustpilot : ''}`}>{sectionTitle}</h2>
          <div className={`${styles.swiperContainer} ${hasTrustpilot ? styles.withTrustpilot : ''}`}>
            <SwiperComponent
              pagination={{ clickable: true }}
              spaceBetween={16}
              breakpoints={{
                1024: {
                  slidesPerView: 3,
                },
                1280: {
                  slidesPerView: 3,
                },
              }}
            >
              {sliderItems.map((item, index) => (
                <div key={index} className={styles.item}>
                  <div>
                    {item.review && <p className={styles.review}>{item.review}</p>}
                    {item.reviewerName && <p className={styles.reviewerName}>{item.reviewerName}</p>}
                  </div>
                </div>
              ))}
            </SwiperComponent>
            {hasTrustpilot ? <div className={styles.trustPilotWrapper}>{trustpilotIframe}</div> : null}
          </div>
        </>
      </div>
    </section>
  );
};

export default Reviews;
